var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-container" }, [
    _c(
      "div",
      {
        staticClass: "filter-container",
        staticStyle: { "text-align": "center" },
      },
      [
        _c(
          "el-row",
          { attrs: { gutter: 24 } },
          [
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c("el-card", { attrs: { shadow: "always" } }, [
                  _c("i", { staticClass: "el-icon-s-platform" }),
                  _vm._v(" "),
                  _c("div", [_vm._v("\n            应用名称\n          ")]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      "\n            " + _vm._s("mscode") + "\n          "
                    ),
                  ]),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c("el-card", { attrs: { shadow: "always" } }, [
                  _c("i", { staticClass: "el-icon-time" }),
                  _vm._v(" "),
                  _c("div", { staticStyle: { "text-align": "left" } }, [
                    _vm._v(
                      "\n            调度服务器时区：" +
                        _vm._s(_vm.systemInfo.timezone) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticStyle: { "text-align": "left" } }, [
                    _vm._v(
                      "\n            调度服务器时区：" +
                        _vm._s(_vm.systemInfo.serverTime) +
                        "\n          "
                    ),
                  ]),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c("el-card", { attrs: { shadow: "always" } }, [
                  _c("i", { staticClass: "el-icon-time" }),
                  _vm._v(" "),
                  _c("div", { staticStyle: { "text-align": "left" } }, [
                    _vm._v(
                      "\n            本地时区：" +
                        _vm._s(
                          Intl.DateTimeFormat().resolvedOptions().timeZone
                        ) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticStyle: { "text-align": "left" } }, [
                    _vm._v(
                      "\n            本地时间：" +
                        _vm._s(_vm.timestamp2Str(new Date().getTime())) +
                        "\n          "
                    ),
                  ]),
                ]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-row",
          [
            _c("el-col", { attrs: { span: 24 } }, [
              _vm._v("\n         \n      "),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-row",
          { attrs: { gutter: 24 } },
          [
            _c(
              "el-col",
              { attrs: { span: 6 } },
              [
                _c("el-card", { attrs: { shadow: "always" } }, [
                  _c("i", { staticClass: "el-icon-orange" }),
                  _vm._v(" "),
                  _c("div", [_vm._v("\n            任务总数\n          ")]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.systemInfo.jobCount) +
                        "\n          "
                    ),
                  ]),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-col",
              { attrs: { span: 6 } },
              [
                _c("el-card", { attrs: { shadow: "always" } }, [
                  _c("i", { staticClass: "el-icon-timer" }),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v("\n            当前运行实例数\n          "),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.systemInfo.runningInstanceCount) +
                        "\n          "
                    ),
                  ]),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-col",
              { attrs: { span: 6 } },
              [
                _c("el-card", { attrs: { shadow: "always" } }, [
                  _c("i", { staticClass: "el-icon-bell" }),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v("\n            近期失败任务数\n          "),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.systemInfo.failedInstanceCount) +
                        "\n          "
                    ),
                  ]),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-col",
              { attrs: { span: 6 } },
              [
                _c("el-card", { attrs: { shadow: "always" } }, [
                  _c("i", { staticClass: "el-icon-cpu" }),
                  _vm._v(" "),
                  _c("div", [_vm._v("\n            集群机器数\n          ")]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.activeWorkerCount) +
                        "\n          "
                    ),
                  ]),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _vm._m(0),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "dashboard-container" }, [
      _c("div", { staticClass: "dashboard-editor-container" }, [
        _c("div", [
          _vm._v(
            "\n        分布式任务调度支持 CRON\n        表达式、固定频率、固定延迟、API定时调度策略；支持单机、广播、Map、MapReduce\n        执行模式；支持在线配置任务依赖关系工作流，以可视化的方式对任务进行编排，支持上下游任务间的数据传递；\n        支持 Spring Bean、内置/外置 Java 类等执行器，一键集成\n        Shell、Python、HTTP、SQL 等处理器。\n      "
          ),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("br"),
          _vm._v(" "),
          _c("b", [_vm._v("适用场景")]),
          _vm._v(" "),
          _c("br"),
          _vm._v(
            "\n        1、有定时执行需求的业务场景：比如每天凌晨全量同步数据、生成业务报表、未支付订单超时取消等。\n        "
          ),
          _c("br"),
          _vm._v(
            "\n        2、有需要全部机器同时执行的业务场景：比如使用广播执行模式清理集群日志。\n        "
          ),
          _c("br"),
          _vm._v(
            "\n        3、有需要分布式处理的业务场景：比如需要更新一大批数据，单机执行耗时非常长，可以使用\n        Map/MapReduce 处理器完成任务的分发，调动整个集群加速计算。\n        "
          ),
          _c("br"),
          _vm._v(
            "\n        4、有需要延迟执行某些任务的业务场景：比如订单过期处理等。\n      "
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }